import { matchPath } from 'react-router-dom';
import { HEADER_BREADCRUMB_RULES } from '@/lib/navigation/routeHeaderBreadcrumbRules';

export function pathnameOnly(path: string): string {
  return path.split('?')[0] ?? path;
}

export function resolveHeaderBreadcrumb(pathname: string): {
  parentLabelKey: string | null;
  parentTo: string | null;
} {
  for (const rule of HEADER_BREADCRUMB_RULES) {
    const match = matchPath({ path: rule.path, end: true }, pathname);
    if (match) {
      return { parentLabelKey: rule.parentLabelKey, parentTo: rule.parentTo };
    }
  }
  return { parentLabelKey: null, parentTo: null };
}
